import clsx from 'clsx';
import type { ReactNode } from 'react';
import type { ContextualColor } from './colors';

export interface ToastNotificationProps {
  color?: 'primary' | ContextualColor;
  header: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
}

/**
 * Use Notifications to deliver summaries of real-time information.
 *
 * Remark: we don't have the "actions" prop and use the more generic "footer" instead
 *
 * @see: https://developer.sgmarkets.com/docs/design-system/v5/components/notifications.html
 *
 * @param footer
 *
 * @param color
 *
 * @param onClose
 *
 * @param header
 *
 * @param content
 *
 */
export function ToastNotification({
  footer,
  color,
  onClose,
  header,
  content,
}: ToastNotificationProps) {
  function handleClose() {
    onClose?.();
  }

  return (
    <div
      className={clsx('notification show', {
        [`notification-${color}`]: color !== undefined,
      })}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="notification-header">
        <span className="fw-medium me-auto">{header}</span>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} />
      </div>
      <div className="notification-body">{content}</div>
      {footer && <div className="notification-footer">{footer}</div>}
    </div>
  );
}
